import { render, staticRenderFns } from "./ProcessesSection.vue?vue&type=template&id=4afa2fdd&scoped=true"
import script from "./ProcessesSection.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesSection.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessesSection.vue?vue&type=style&index=0&id=4afa2fdd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa2fdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4afa2fdd')) {
      api.createRecord('4afa2fdd', component.options)
    } else {
      api.reload('4afa2fdd', component.options)
    }
    module.hot.accept("./ProcessesSection.vue?vue&type=template&id=4afa2fdd&scoped=true", function () {
      api.rerender('4afa2fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessesSection/ProcessesSection.vue"
export default component.exports